import React from "react";
import Routes from "./routes";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import "./App.css";
import DateFnsUtils from "@date-io/date-fns";

function App() {
  return (
    <div className={"mainWrapper"} id="myId">
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Routes />
      </MuiPickersUtilsProvider>
    </div>
  );
}

export default App;
